import { Phone } from "lucide-react";
import { motion } from "framer-motion";

export default function FloatingCall() {
  return (
    <motion.a
      href="tel:0415464900"
      data-testid="floating-call-button"
      aria-label="Call Sami Fab on 0415 464 900"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1.2, type: "spring", stiffness: 260, damping: 18 }}
      className="md:hidden fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-[#007bff] text-white flex items-center justify-center shadow-xl shadow-[#007bff]/40 active:scale-95 transition-transform duration-150"
    >
      <span className="absolute inset-0 rounded-full bg-[#007bff] animate-ping opacity-25" aria-hidden />
      <Phone size={22} strokeWidth={2.25} className="relative" />
    </motion.a>
  );
}
